import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import StyledFav from "./StyledFav";
import FavItems from "./FavItems";
import { fetchFavProducts } from "../../store/reducers/createProfile/apithunk";
import { ToastNotifyError } from "../../components/CommonComponents/Toast/ToastNotify";
import { useDispatch } from "react-redux";
import rollbar from "../../rollbarConfig";

const FavouritesSection = ({ loaderHeight = "94%" }) => {
  const [favData, setFavData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageInfo, setPageInfo] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10)
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const res = await dispatch(fetchFavProducts(`?page_no=${pageNo}&page_size=${pageSize}`));
        const { data, status, message,
          _meta } = res?.payload;
        if (status) {
          setFavData(data);
          setPageInfo(_meta);
        } else {
          ToastNotifyError(message);
        }
      } catch (error) {
        rollbar.error("Error message", error);
        console.error("Login failed:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [pageNo, pageSize]);

  return (
    <StyledFav>
      <Box className="main-container">
        <FavItems
          className="text-long-truncate"
          sxMobileHeight={pageInfo?.total_pages <= 3 ? "calc(100vh - 150px)" : "calc(100vh - 183px)"}
          loaderHeight={loaderHeight}
          pageInfo={pageInfo}
          pageNo={pageNo}
          pageSize={pageInfo?.total_count >= 10 ? pageSize : pageInfo?.total_count}
          setPageNo={setPageNo}
          setPageSize={setPageSize}
          loading={loading}
          favData={favData}
        />
      </Box>
    </StyledFav>
  );
};

export default FavouritesSection;
